import React from "react";

interface ModalConfirmStatusProps {
  open: boolean;
  title?: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  confirmType?: "approve" | "reject" | "remove";
}

const ModalConfirmStatus: React.FC<ModalConfirmStatusProps> = ({
  open,
  title,
  description,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  onConfirm,
  onCancel,
  loading = false,
  confirmType = "approve",
}) => {
  if (!open) return null;

  const getConfirmButtonClass = () => {
    let base = "px-4 py-2 rounded font-semibold border ";
    switch (confirmType) {
      case "approve":
        base += "bg-greenPrimary hover:bg-green-700 text-white ";
        break;
      case "reject":
        base += "bg-redPrimary hover:bg-red-700 text-white ";
        break;
      case "remove":
        base += "bg-gray hover:bg-gray-600 text-white ";
        break;
    }
    if (loading) {
      base += "opacity-60 cursor-not-allowed ";
    }
    return base.trim();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
        {title && <h2 className="text-xl font-bold mb-4">{title}</h2>}
        {description && <p className="mb-6 text-gray-700">{description}</p>}

        <div className="flex justify-end gap-3">
          <button
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>

          <button
            className={getConfirmButtonClass()}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Processando..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmStatus;
